import React from 'react';
import _ from 'lodash';

import styles from '../../modules/Filters.module.scss';

const FilterCheckButton = (props) => {
    const {checked, onChange, loadingFilters, filters, onclickGAEvent} = props

    const onNextDayChange = () => {
        if (!nextDay.data[0]?.disabled) {
            onChange(nextDay);
            loadingFilters(true);

            onclickGAEvent({
                action: 'FP - Top Level',
                label: (!checked) ? 'Express products' : 'All Products',
            })
        }
    }

    //if filters are not ready
    if (filters.length < 1) {
        return null;
    }

    //get the next day filter
    const nextDay = {
        ..._.find(filters, {name: 'nextDay'}),
        checked: !checked,
        name: 'es',
        value: 1
    };

    return (
        <div className={styles.dropdownItem}>
            <div
                className={styles.filterCheckbox}
                onClick={() => {
                    onNextDayChange();
                }}>
                <input
                    className={styles.filterCheckboxInput}
                    type="checkbox"
                    value={1}
                    id={nextDay.id}
                    checked={checked}
                    disabled={nextDay.data[0]?.disabled}
                    onChange={() => onNextDayChange()}
                />
                <label
                    className={styles.filterCheckboxLabel}
                    htmlFor={nextDay.id}>
                    {nextDay.label}
                </label>
            </div>
        </div>
    );
};

export default FilterCheckButton;
